import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleRight } from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import Link from "next/link";
import { formatDate } from "../lib/utils/dateUtils";

const BlogArticleCard = ({ article, children, imageClassName = "" }) => {
  const articleUrl = `/blog/${article.id}/${article.metadata.meta_url}`;

  return (
    <div className="flex flex-col md:flex-row rounded-lg bg-white border border-gray-200 shadow-md hover:shadow-lg transition-shadow duration-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white md:max-w-xl">
      <figure>
        <Link href={articleUrl} className="h-full flex">
          <img
            src={article.metadata.image.url}
            alt={article.title}
            width={300}
            height={200}
            className={`w-full h-48 object-cover rounded-t-lg md:!rounded-none md:!rounded-s-lg hover:opacity-60 transition duration-300 ease-in-out ${imageClassName}`}
          />
        </Link>
      </figure>
      <div className="card-body p-3">
        <div className="lg:h-full">
          {children}
          <div>
            <div className="italic text-xs">
              Publié le : {formatDate(article.metadata.date_de_publication)}
            </div>
            <div className="badge badge-outline capitalize">
              {article.metadata.theme &&
                article.metadata.theme.map((theme, index) => (
                  <span
                    key={index}
                    className="badge badge-outline capitalize ml-3">
                    {theme.title}
                  </span>
                ))}
            </div>
          </div>
          <div className="card-actions mt-3">
            <Link
              href={articleUrl}
              className="text-xs px-2 py-1 rounded-md bg-gray-200 hover:bg-gray-100 transition duration-300 ease-in-out">
              <FontAwesomeIcon icon={faArrowAltCircleRight} className="mr-2" />
              Lire la suite
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

BlogArticleCard.propTypes = {
  article: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    metadata: PropTypes.object,
  }).isRequired,
  children: PropTypes.node,
  imageClassName: PropTypes.string,
};

export default BlogArticleCard;
